import axios from 'axios';

// Coordinates for Bareilly (Nathnagri)
const BAREILLY_COORDS = {
  lat: 28.3619,
  lon: 79.4217,
  tzone: 5.5
};

// Sanskrit / Hindi translations and information maps
export const VAARA_MAP = {
  0: { en: "Sunday", hi: "रविवार (Raviwar)", ruling: "Sun (Surya)", color: "text-amber-600 bg-amber-50" },
  1: { en: "Monday", hi: "सोमवार (Somwar)", ruling: "Moon (Chandra)", color: "text-blue-500 bg-blue-50" },
  2: { en: "Tuesday", hi: "मंगलवार (Mangalwar)", ruling: "Mars (Mangal)", color: "text-red-600 bg-red-50" },
  3: { en: "Wednesday", hi: "बुधवार (Budhwar)", ruling: "Mercury (Budh)", color: "text-emerald-600 bg-emerald-50" },
  4: { en: "Thursday", hi: "गुरुवार (Guruwar)", ruling: "Jupiter (Guru)", color: "text-yellow-600 bg-yellow-50" },
  5: { en: "Friday", hi: "शुक्रवार (Shukrawar)", ruling: "Venus (Shukra)", color: "text-pink-600 bg-pink-50" },
  6: { en: "Saturday", hi: "शनिवार (Shaniwar)", ruling: "Saturn (Shani)", color: "text-purple-600 bg-purple-50" }
};

export const TITHI_MAP = {
  1: { en: "Pratipada", hi: "प्रतिपदा (Pratipada)", deity: "Agni", description: "Good for starting new things, ceremonies, and travel." },
  2: { en: "Dwitiya", hi: "द्वितीया (Dwitiya)", deity: "Brahma", description: "Auspicious for building, laying foundations, and weddings." },
  3: { en: "Tritiya", hi: "तृतीया (Tritiya)", deity: "Gauri", description: "Excellent for cutting hair, music, and learning." },
  4: { en: "Chaturthi", hi: "चतुर्थी (Chaturthi)", deity: "Ganesha", description: "Favorable for removing obstacles, worshiping Lord Ganesha." },
  5: { en: "Panchami", hi: "पंचमी (Panchami)", deity: "Naagas", description: "Highly auspicious for administering medicine and educational pursuits." },
  6: { en: "Shashthi", hi: "षष्ठी (Shashthi)", deity: "Kartikeya", description: "Favorable for fighting disputes, making new friends, and building." },
  7: { en: "Saptami", hi: "सप्तमी (Saptami)", deity: "Surya", description: "Auspicious for starting journeys, buying vehicles, and music." },
  8: { en: "Ashtami", hi: "अष्टमी (Ashtami)", deity: "Shiva / Durga", description: "Favorable for meditation, prayers, and fasting." },
  9: { en: "Navami", hi: "नवमी (Navami)", deity: "Durga", description: "Favorable for strategic planning, physical efforts, and bold moves." },
  10: { en: "Dashami", hi: "दशमी (Dashami)", deity: "Yama", description: "Excellent for starting new ventures, business, and travel." },
  11: { en: "Ekadashi", hi: "एकादशी (Ekadashi)", deity: "Vishnu", description: "Sacred day of fasting, spiritual purification, and worship." },
  12: { en: "Dwadashi", hi: "द्वादशी (Dwadashi)", deity: "Sun (Adityas)", description: "Auspicious for charity, religious duties, and study." },
  13: { en: "Trayodashi", hi: "त्रयोदशी (Trayodashi)", deity: "Kamadeva", description: "Very favorable for romance, friendships, and new clothes." },
  14: { en: "Chaturdashi", hi: "चतुर्दशी (Chaturdashi)", deity: "Shiva", description: "Auspicious for worshiping Lord Shiva, spiritual sadhana." },
  15: { en: "Purnima", hi: "पूर्णिमा (Purnima)", deity: "Moon (Chandra)", description: "Full Moon. Highly auspicious for all religious rites, peace, and abundance." },
  30: { en: "Amavasya", hi: "अमावस्या (Amavasya)", deity: "Pitrus", description: "New Moon. Auspicious for ancestral rituals, prayers, and inner reflection." }
};

export const NAKSHATRA_MAP = [
  { en: "Ashwini", hi: "अश्विनी", ruler: "Ketu", deity: "Ashwini Kumaras", quality: "Swift/Light" },
  { en: "Bharani", hi: "भरणी", ruler: "Venus", deity: "Yama", quality: "Fierce/Active" },
  { en: "Krittika", hi: "कृत्तिका", ruler: "Sun", deity: "Agni", quality: "Mixed" },
  { en: "Rohini", hi: "रोहिणी", ruler: "Moon", deity: "Brahma", quality: "Fixed/Creative" },
  { en: "Mrigashira", hi: "मृगशिरा", ruler: "Mars", deity: "Soma", quality: "Soft/Gentle" },
  { en: "Ardra", hi: "आर्द्रा", ruler: "Rahu", deity: "Rudra", quality: "Sharp/Dreadful" },
  { en: "Punarvasu", hi: "पुनर्वसु", ruler: "Jupiter", deity: "Aditi", quality: "Movable/Temporary" },
  { en: "Pushya", hi: "पुष्य", ruler: "Saturn", deity: "Brihaspati", quality: "Nourishing/Auspicious" },
  { en: "Ashlesha", hi: "आश्लेषा", ruler: "Mercury", deity: "Nagas", quality: "Sharp/Clinging" },
  { en: "Magha", hi: "मघा", ruler: "Ketu", deity: "Pitrus", quality: "Fierce/Royal" },
  { en: "Purva Phalguni", hi: "पूर्वा फाल्गुनी", ruler: "Venus", deity: "Bhaga", quality: "Fierce/Sensual" },
  { en: "Uttara Phalguni", hi: "उत्तरा फाल्गुनी", ruler: "Sun", deity: "Aryaman", quality: "Fixed/Noble" },
  { en: "Hasta", hi: "हस्त", ruler: "Moon", deity: "Savitar", quality: "Swift/Light" },
  { en: "Chitra", hi: "चित्रा", ruler: "Mars", deity: "Vishwakarma", quality: "Soft/Gentle" },
  { en: "Swati", hi: "स्वाती", ruler: "Rahu", deity: "Vayu", quality: "Movable/Temporary" },
  { en: "Vishakha", hi: "विशाखा", ruler: "Jupiter", deity: "Indra & Agni", quality: "Mixed/Sharp" },
  { en: "Anuradha", hi: "अनुराधा", ruler: "Saturn", deity: "Mitra", quality: "Soft/Gentle" },
  { en: "Jyeshtha", hi: "ज्येष्ठा", ruler: "Mercury", deity: "Indra", quality: "Sharp/Dreadful" },
  { en: "Mula", hi: "मूल", ruler: "Ketu", deity: "Nirriti", quality: "Sharp/Root" },
  { en: "Purva Ashadha", hi: "पूर्वाषाढ़ा", ruler: "Venus", deity: "Apah", quality: "Fierce/Invincible" },
  { en: "Uttara Ashadha", hi: "उत्तराषाढ़ा", ruler: "Sun", deity: "Vishwadevas", quality: "Fixed/Victorious" },
  { en: "Shravana", hi: "श्रवण", ruler: "Moon", deity: "Vishnu", quality: "Movable/Listening" },
  { en: "Dhanishtha", hi: "धनिष्ठा", ruler: "Mars", deity: "Eight Vasus", quality: "Movable/Wealthy" },
  { en: "Shatabhisha", hi: "शतभिषा", ruler: "Rahu", deity: "Varuna", quality: "Movable/Healing" },
  { en: "Purva Bhadrapada", hi: "पूर्वा भाद्रपद", ruler: "Jupiter", deity: "Aja Ekapada", quality: "Fierce/Spiritual" },
  { en: "Uttara Bhadrapada", hi: "उत्तरा भाद्रपद", ruler: "Saturn", deity: "Ahirbudhnya", quality: "Fixed/Wisdom" },
  { en: "Revati", hi: "रेवती", ruler: "Mercury", deity: "Pushan", quality: "Soft/Gentle" }
];

export const YOGA_MAP = [
  { en: "Vishkumbha", hi: "विष्कम्भ", description: "Overcoming obstacles; triumphant." },
  { en: "Preeti", hi: "प्रीति", description: "Spreads joy, love, and affection." },
  { en: "Ayushman", hi: "आयुष्मान्", description: "Good health and longevity." },
  { en: "Saubhagya", hi: "सौभाग्य", description: "Increases fortune, luck, and beauty." },
  { en: "Shobhana", hi: "शोभन", description: "Splendid, bright, and highly auspicious." },
  { en: "Atiganda", hi: "अतिगण्ड", description: "Challenging; requires patience and care." },
  { en: "Sukarma", hi: "सुकर्मा", description: "Excellent for good deeds, noble actions." },
  { en: "Dhriti", hi: "धृति", description: "Patience, concentration, and stability." },
  { en: "Shoola", hi: "शूल", description: "Sharp, argumentative; avoid disputes." },
  { en: "Ganda", hi: "गण्ड", description: "Obstacles; handle affairs with caution." },
  { en: "Vriddhi", hi: "वृद्धि", description: "Growth, prosperity, and success." },
  { en: "Dhruva", hi: "ध्रुव", description: "Fixed, reliable, and strong foundations." },
  { en: "Vyaghata", hi: "व्याघात", description: "Sudden events; be mindful and alert." },
  { en: "Harshana", hi: "हर्षण", description: "Thrilling, brings pleasure and happiness." },
  { en: "Vajra", hi: "वज्र", description: "Diamond-hard, powerful, and energetic." },
  { en: "Siddhi", hi: "सिद्धि", description: "Accomplishment and spiritual fulfillment." },
  { en: "Vyatipata", hi: "व्यतिपात", description: "Complex; suited for inner sadhana." },
  { en: "Variyan", hi: "वरीयान्", description: "Brings wealth, comfort, and luxury." },
  { en: "Parigha", hi: "परिघ", description: "Shielding, protective, overcoming foes." },
  { en: "Shiva", hi: "शिव", description: "Highly auspicious, pure, and meditative." },
  { en: "Siddha", hi: "सिद्ध", description: "Accomplished, perfect, and successful." },
  { en: "Sadhya", hi: "साध्य", description: "Feasible, achievable with dedication." },
  { en: "Shubha", hi: "शुभ", description: "Fortunate, beautiful, and auspicious." },
  { en: "Shukla", hi: "शुक्ल", description: "Bright, clean, and positive growth." },
  { en: "Brahma", hi: "ब्रह्म", description: "Creative, expansive, and high intellect." },
  { en: "Indra", hi: "इन्द्र", description: "Leadership, power, and high status." },
  { en: "Vaidhriti", hi: "वैधृति", description: "Highly transformative; meditative." }
];

export const KARANA_MAP = {
  bava: { en: "Bava", hi: "बव", ruler: "Indra", nature: "Auspicious, good for health" },
  balava: { en: "Balava", hi: "बालव", ruler: "Brahma", nature: "Auspicious, excellent for learning" },
  kaulava: { en: "Kaulava", hi: "कौलव", ruler: "Moon (Chandra)", nature: "Social affairs, friendships" },
  taitila: { en: "Taitila", hi: "तैतिल", ruler: "Mercury (Budh)", nature: "Building, housewarmings" },
  gara: { en: "Gara", hi: "गर", ruler: "Earth (Bhumi)", nature: "Agriculture, land work" },
  vanija: { en: "Vanija", hi: "वणिज", ruler: "Lakshmi", nature: "Trade, transaction, business" },
  vishti: { en: "Vishti (Bhadra)", hi: "विष्टि (भद्रा)", ruler: "Yama", nature: "Challenging; avoid starting ventures" },
  shakuni: { en: "Shakuni", hi: "शकुनि", ruler: "Garuda", nature: "Ancestral work, spiritual remedies" },
  chatushpada: { en: "Chatushpada", hi: "चतुष्पद", ruler: "Vrishabha", nature: "Animal husbandry, charity" },
  naga: { en: "Naga", hi: "नाग", ruler: "Shesha", nature: "Foretelling, subtle energy work" },
  kintughna: { en: "Kintughna", hi: "किन्तुघ्न", ruler: "Vayu", nature: "Starting auspicious undertakings" }
};

// ----------------------------------------------------
// LUNAR CALENDAR MATHEMATICAL APPROXIMATOR (MOCK ENGINE)
// ----------------------------------------------------

/**
 * Computes highly realistic daily Hindu calendar data for any date in 2026.
 */
export const calculateMockPanchang = (date) => {
  const targetDate = new Date(date);
  
  // Day of week
  const vaaraIndex = targetDate.getDay();
  const vaara = VAARA_MAP[vaaraIndex];
  
  // Days elapsed since Jan 1, 2026
  const start2026 = new Date(2026, 0, 1);
  const diffTime = targetDate - start2026;
  const diffDays = Math.max(0, Math.floor(diffTime / (1000 * 60 * 60 * 24)));
  
  // Approximate reference new moons in 2026 (Amavasya dates)
  const newMoons2026 = [
    new Date(2026, 0, 18), // Jan 18
    new Date(2026, 1, 17), // Feb 17
    new Date(2026, 2, 18), // Mar 18
    new Date(2026, 3, 17), // Apr 17
    new Date(2026, 4, 16), // May 16
    new Date(2026, 5, 15), // Jun 15
    new Date(2026, 6, 14), // Jul 14
    new Date(2026, 7, 12), // Aug 12
    new Date(2026, 8, 11), // Sep 11
    new Date(2026, 9, 10), // Oct 10
    new Date(2026, 10, 9),  // Nov 9
    new Date(2026, 11, 9)   // Dec 9
  ];
  
  // Find the closest preceding new moon
  let prevNewMoon = newMoons2026[0];
  for (let i = 0; i < newMoons2026.length; i++) {
    if (newMoons2026[i] <= targetDate) {
      prevNewMoon = newMoons2026[i];
    }
  }
  
  // If target date is before Jan 18, use a Dec 2025 New Moon reference (approx Dec 20, 2025)
  if (targetDate < newMoons2026[0]) {
    prevNewMoon = new Date(2025, 11, 20);
  }
  
  const synodicMonth = 29.53059; // days
  const timeSinceNewMoon = (targetDate - prevNewMoon) / (1000 * 60 * 60 * 24);
  const lunarAge = timeSinceNewMoon % synodicMonth;
  
  // Calculate precise Tithi (1 to 30)
  // Tithi is determined by difference between Moon and Sun longitude.
  // Each Tithi represents a 12-degree elongation (360 degrees / 30 Tithis).
  const tithiRaw = (lunarAge / synodicMonth) * 30;
  let tithiNumber = Math.ceil(tithiRaw);
  if (tithiNumber > 30) tithiNumber = 30;
  if (tithiNumber <= 0) tithiNumber = 1;
  
  // Tithi end time simulation (e.g. Tithi ends some time in the afternoon/evening)
  // Seed with diffDays to keep it consistent on reload
  const tithiSeed = (diffDays * 7) % 24;
  const tithiEndHour = Math.floor(8 + (tithiSeed % 12));
  const tithiEndMin = Math.floor((diffDays * 13) % 60);
  const tithiEndStr = `${tithiEndHour.toString().padStart(2, '0')}:${tithiEndMin.toString().padStart(2, '0')} PM`;
  
  // Determine Paksha & Tithi representation
  let paksha = "Shukla";
  let displayTithiNum = tithiNumber;
  if (tithiNumber > 15 && tithiNumber < 30) {
    paksha = "Krishna";
    displayTithiNum = tithiNumber - 15;
  } else if (tithiNumber === 30) {
    paksha = "Krishna";
    displayTithiNum = 30;
  }
  
  const tithiInfo = TITHI_MAP[displayTithiNum] || TITHI_MAP[1];
  const tithiName = {
    en: `${paksha} ${tithiInfo.en}`,
    hi: `${paksha === "Shukla" ? "शुक्ल पक्ष" : "कृष्ण पक्ष"} - ${tithiInfo.hi}`
  };
  
  // Nakshatra Calculation (Moon is in 27 Nakshatras during 27.3217 days)
  // Sidereal Moon cycle. On Jan 1, 2026, Moon is in Rohini (index 3, which is 4th Nakshatra)
  const nakshatraCycle = 27.3217;
  const nakshatraRaw = (4 + (diffDays * (27 / nakshatraCycle))) % 27;
  const nakshatraIdx = Math.floor(nakshatraRaw);
  const nakshatraInfo = NAKSHATRA_MAP[nakshatraIdx] || NAKSHATRA_MAP[0];
  
  // End time simulation
  const nakSeed = (diffDays * 11) % 24;
  const nakEndHour = Math.floor(6 + (nakSeed % 12));
  const nakEndMin = Math.floor((diffDays * 19) % 60);
  const nakEndStr = `${nakEndHour.toString().padStart(2, '0')}:${nakEndMin.toString().padStart(2, '0')} PM`;
  
  // Yoga Calculation (27 Yogas. Combination of Sun & Moon longitudes)
  const yogaRaw = (diffDays * (27 / 27.3217 + 27 / 365.2425)) % 27;
  const yogaIdx = Math.floor(yogaRaw);
  const yogaInfo = YOGA_MAP[yogaIdx] || YOGA_MAP[0];
  
  // End time simulation
  const yogaSeed = (diffDays * 3) % 24;
  const yogaEndHour = Math.floor(4 + (yogaSeed % 14));
  const yogaEndMin = Math.floor((diffDays * 29) % 60);
  const yogaEndStr = `${yogaEndHour.toString().padStart(2, '0')}:${yogaEndMin.toString().padStart(2, '0')} PM`;
  
  // Karana Calculation (1 Tithi has 2 Karanas. Total 11 Karanas in cycles)
  // The first Karana starts at second half of Pratipada.
  // There are 4 fixed Karanas (Shakuni, Chatushpada, Naga, Kintughna)
  // and 7 rotating Karanas (Bava, Balava, Kaulava, Taitila, Gara, Vanija, Vishti)
  let karanaKey = "bava";
  const karanaProgress = Math.floor(tithiRaw * 2); // 1 to 60 half-tithis
  
  if (karanaProgress === 1) {
    karanaKey = "kintughna";
  } else if (karanaProgress >= 58) {
    // Fixed ones at the end of lunar cycle
    if (karanaProgress === 58) karanaKey = "shakuni";
    else if (karanaProgress === 59) karanaKey = "chatushpada";
    else karanaKey = "naga";
  } else {
    // Rotating cycle of 7
    const rotList = ["bava", "balava", "kaulava", "taitila", "gara", "vanija", "vishti"];
    const rotIdx = (karanaProgress - 2) % 7;
    karanaKey = rotList[rotIdx] || "bava";
  }
  const karanaInfo = KARANA_MAP[karanaKey] || KARANA_MAP["bava"];
  
  // End time simulation
  const karanaEndHour = Math.floor((tithiEndHour + 12) % 12 || 12);
  const karanaEndMin = Math.floor((tithiEndMin + 30) % 60);
  const karanaEndStr = `${karanaEndHour.toString().padStart(2, '0')}:${karanaEndMin.toString().padStart(2, '0')} PM`;
  
  // Hindu Month approximation based on dates in 2026
  // Approximate starting Gregorian dates of Hindu Months in 2026
  const HINDU_MONTHS = [
    { nameEn: "Pausha", nameHi: "पौष (Pausha)", start: new Date(2025, 11, 21) },
    { nameEn: "Magha", nameHi: "माघ (Magha)", start: new Date(2026, 0, 19) },
    { nameEn: "Phalguna", nameHi: "फाल्गुन (Phalguna)", start: new Date(2026, 1, 18) },
    { nameEn: "Chaitra", nameHi: "चैत्र (Chaitra)", start: new Date(2026, 2, 19) }, // Hindu New Year (Pratipada)
    { nameEn: "Vaishakha", nameHi: "वैशाख (Vaishakha)", start: new Date(2026, 3, 18) },
    { nameEn: "Jyeshtha", nameHi: "ज्येष्ठ (Jyeshtha)", start: new Date(2026, 4, 17) },
    { nameEn: "Ashadha", nameHi: "आषाढ़ (Ashadha)", start: new Date(2026, 5, 16) },
    { nameEn: "Shravana", nameHi: "श्रावण (Shravana)", start: new Date(2026, 6, 15) },
    { nameEn: "Bhadrapada", nameHi: "भाद्रपद (Bhadrapada)", start: new Date(2026, 7, 13) },
    { nameEn: "Ashvina", nameHi: "आश्विन (Ashvina)", start: new Date(2026, 8, 12) },
    { nameEn: "Kartika", nameHi: "कार्तिक (Kartika)", start: new Date(2026, 9, 11) },
    { nameEn: "Margashirsha", nameHi: "मार्गशीर्ष (Margashirsha)", start: new Date(2026, 10, 10) },
    { nameEn: "Pausha", nameHi: "पौष (Pausha)", start: new Date(2026, 11, 10) }
  ];
  
  let currentHinduMonth = HINDU_MONTHS[HINDU_MONTHS.length - 1];
  for (let i = 0; i < HINDU_MONTHS.length; i++) {
    if (targetDate >= HINDU_MONTHS[i].start) {
      currentHinduMonth = HINDU_MONTHS[i];
    }
  }
  
  // Sunrise/Sunset calculations for Bareilly (sine wave based on declination)
  // Day length ranges from ~10.4 hours in Dec to ~13.9 hours in Jun
  const dayOfYear = diffDays + 1;
  const radians = ((dayOfYear - 172) * 2 * Math.PI) / 365.25;
  const dayLengthHours = 12.15 + 1.75 * Math.cos(radians);
  
  const midDayHour = 12.18; // Solar noon around 12:11 PM - 12:25 PM Bareilly time
  const sunriseDec = midDayHour - dayLengthHours / 2;
  const sunsetDec = midDayHour + dayLengthHours / 2;
  
  const formatDecTime = (decimalTime) => {
    const hours = Math.floor(decimalTime);
    const mins = Math.floor((decimalTime - hours) * 60);
    const period = hours >= 12 ? "PM" : "AM";
    const displayHour = hours % 12 || 12;
    return `${displayHour.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')} ${period}`;
  };
  
  const sunriseStr = formatDecTime(sunriseDec);
  const sunsetStr = formatDecTime(sunsetDec);
  
  // Moonrise and Moonset times depend heavily on Tithi (shifted ~50 mins each day)
  // New Moon: rises at sunrise, sets at sunset.
  // Full Moon: rises at sunset, sets at sunrise.
  const moonriseDec = (sunriseDec + (tithiNumber - 1) * 0.8) % 24;
  const moonsetDec = (sunsetDec + (tithiNumber - 1) * 0.8) % 24;
  
  const moonriseStr = formatDecTime(moonriseDec);
  const moonsetStr = formatDecTime(moonsetDec);
  
  return {
    isMock: true,
    date: date,
    vaara: {
      en: vaara.en,
      hi: vaara.hi,
      ruling: vaara.ruling,
      color: vaara.color
    },
    tithi: {
      number: tithiNumber,
      paksha: paksha,
      name: tithiName,
      deity: tithiInfo.deity,
      description: tithiInfo.description,
      endTime: tithiEndStr
    },
    nakshatra: {
      name: { en: nakshatraInfo.en, hi: nakshatraInfo.hi },
      ruler: nakshatraInfo.ruler,
      deity: nakshatraInfo.deity,
      quality: nakshatraInfo.quality,
      endTime: nakEndStr
    },
    yoga: {
      name: { en: yogaInfo.en, hi: yogaInfo.hi },
      description: yogaInfo.description,
      endTime: yogaEndStr
    },
    karana: {
      name: { en: karanaInfo.en, hi: karanaInfo.hi },
      ruler: karanaInfo.ruler,
      nature: karanaInfo.nature,
      endTime: karanaEndStr
    },
    hinduMonth: {
      en: currentHinduMonth.nameEn,
      hi: currentHinduMonth.nameHi
    },
    timings: {
      sunrise: sunriseStr,
      sunset: sunsetStr,
      moonrise: moonriseStr,
      moonset: moonsetStr
    }
  };
};

// ----------------------------------------------------
// LIVE API GATEWAY CALLER
// ----------------------------------------------------

/**
 * Fetches complete Panchang data from freeastrologyapi.com or falls back to calculations.
 */
export const getPanchangData = async (dateStr) => {
  const dateObj = new Date(dateStr);
  const apiKey = process.env.REACT_APP_FREE_ASTROLOGY_API_KEY;
  
  // If no API key is specified, gracefully default to the mock mathematical engine immediately!
  if (!apiKey) {
    console.log("[PanchangAPI] No API key detected. Running offline Astrological Math Engine...");
    // Artificial small delay for premium UX loader representation
    await new Promise(resolve => setTimeout(resolve, 600));
    return calculateMockPanchang(dateObj);
  }
  
  try {
    const payload = {
      day: dateObj.getDate(),
      month: dateObj.getMonth() + 1,
      year: dateObj.getFullYear(),
      hour: 12,
      min: 0,
      lat: BAREILLY_COORDS.lat,
      lon: BAREILLY_COORDS.lon,
      tzone: BAREILLY_COORDS.tzone
    };
    
    console.log("[PanchangAPI] Requesting complete-panchang data...", payload);
    const response = await axios.post('https://json.freeastrologyapi.com/complete-panchang', payload, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      },
      timeout: 8000
    });
    
    if (response.status === 200 && response.data) {
      console.log("[PanchangAPI] Success!", response.data);
      
      const apiData = response.data;
      
      // Parse the response properties carefully. Different plans return varied responses.
      // Map API properties safely to our structured object, merging with mock engine estimates if some are missing.
      const fallback = calculateMockPanchang(dateObj);
      
      return {
        isMock: false,
        date: dateStr,
        vaara: {
          en: apiData.vaara || fallback.vaara.en,
          hi: apiData.vaara_hindi ? `${apiData.vaara_hindi} (Vaara)` : fallback.vaara.hi,
          ruling: fallback.vaara.ruling,
          color: fallback.vaara.color
        },
        tithi: {
          number: apiData.tithi?.number || fallback.tithi.number,
          paksha: apiData.tithi?.paksha || fallback.tithi.paksha,
          name: {
            en: apiData.tithi?.name || fallback.tithi.name.en,
            hi: apiData.tithi?.name_hindi ? `${apiData.tithi?.paksha === "Shukla" ? "शुक्ल पक्ष" : "कृष्ण पक्ष"} - ${apiData.tithi?.name_hindi}` : fallback.tithi.name.hi
          },
          deity: apiData.tithi?.deity || fallback.tithi.deity,
          description: fallback.tithi.description,
          endTime: apiData.tithi?.end_time || fallback.tithi.endTime
        },
        nakshatra: {
          name: { 
            en: apiData.nakshatra?.name || fallback.nakshatra.name.en, 
            hi: apiData.nakshatra?.name_hindi || fallback.nakshatra.name.hi 
          },
          ruler: apiData.nakshatra?.ruler || fallback.nakshatra.ruler,
          deity: apiData.nakshatra?.deity || fallback.nakshatra.deity,
          quality: fallback.nakshatra.quality,
          endTime: apiData.nakshatra?.end_time || fallback.nakshatra.endTime
        },
        yoga: {
          name: { 
            en: apiData.yoga?.name || fallback.yoga.name.en, 
            hi: apiData.yoga?.name_hindi || fallback.yoga.name.hi 
          },
          description: fallback.yoga.description,
          endTime: apiData.yoga?.end_time || fallback.yoga.endTime
        },
        karana: {
          name: { 
            en: apiData.karana?.name || fallback.karana.name.en, 
            hi: apiData.karana?.name_hindi || fallback.karana.name.hi 
          },
          ruler: fallback.karana.ruler,
          nature: fallback.karana.nature,
          endTime: apiData.karana?.end_time || fallback.karana.endTime
        },
        hinduMonth: {
          en: apiData.hindu_month?.amanta || fallback.hinduMonth.en,
          hi: apiData.hindu_month?.purnimanta ? `${apiData.hindu_month?.purnimanta}` : fallback.hinduMonth.hi
        },
        timings: {
          sunrise: apiData.sunrise || fallback.timings.sunrise,
          sunset: apiData.sunset || fallback.timings.sunset,
          moonrise: apiData.moonrise || fallback.timings.moonrise,
          moonset: apiData.moonset || fallback.timings.moonset
        }
      };
    }
    
    throw new Error(`API responded with code ${response.status}`);
  } catch (error) {
    console.warn("[PanchangAPI] Error fetching live astrology data. Failing over to Astrological Math Engine...", error);
    // If the API call fails (like 403, 401 or network outage), we transparently failover to the local calculator!
    return calculateMockPanchang(dateObj);
  }
};
